import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import s from './MoneyPromoButton.scss';
const MoneyPromoButton = ({ user , moneyPromo , relevantDeviation  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(BiLink, {
        className: s['root'],
        href: moneyPromo === 'tier' ? Url.userSubscriptionsPath({
            username: user.username
        }) : Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS),
        biData: relevantDeviation && BiData({
            evid: moneyPromo === 'tier' ? BiEventType.VIEW_SUBSCRIPTION_TAB : BiEventType.VIEW_COMMISSIONS_TAB,
            typeid: relevantDeviation.typeId,
            itemid: relevantDeviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION
        })
    }, t(`submissionDetailsHeader.moneyPromo.var.${moneyPromo}.CTA`));
};
MoneyPromoButton.displayName = 'MoneyPromoButton';
export default MoneyPromoButton;
